"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var InfoTooltip = function InfoTooltip(_ref) {
  var tooltip = _ref.tooltip;
  return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: tooltip,
    placement: "top"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)));
};
InfoTooltip.propTypes = {
  tooltip: _propTypes["default"].string.isRequired
};
var _default = InfoTooltip;
exports["default"] = _default;